import * as React from "react";
import { RadioGroup as RadioGroupPrimitive } from "radix-ui";
import { cn } from "@/shared/utils/utils";

const RadioGroup = ({
  className,
  ...props
}: React.ComponentProps<
  typeof RadioGroupPrimitive.Root
>): React.ReactElement => {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn("grid gap-3", className)}
      {...props}
    />
  );
};

const RadioGroupItem = ({
  className,
  ...props
}: React.ComponentProps<
  typeof RadioGroupPrimitive.Item
>): React.ReactElement => {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        `
        relative
        size-5
        rounded-full
        border
        border-border
        bg-white
        transition-all
        focus-visible:outline-none
        focus-visible:ring-1
        focus-visible:ring-foreground/80
        data-[state=checked]:border-primary
        data-[state=checked]:bg-primary
        disabled:bg-input
        disabled:pointer-events-none
        `,
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="flex items-center justify-center"
      >
        <div className="size-2.5 rounded-full bg-white" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
};

export { RadioGroup, RadioGroupItem };
